import * as React from 'react'
import CircularProgress from '@mui/material/CircularProgress'

export default function GradientCircularProgressIndicator({
    size = 40,
    sx = {},
}) {
    return (
        <React.Fragment>
            <svg width={0} height={0}>
                <defs>
                    <linearGradient id="artos_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#00CED1" /> 
                        <stop offset="50%" stopColor="#409BA3" />
                        <stop offset="100%" stopColor="#1F477D" />
                    </linearGradient>
                </defs>
            </svg>
            <CircularProgress 
                size={size}
                sx={{ 
                    'svg circle': { stroke: 'url(#artos_gradient)' },
                    ...sx
                }}
            />
        </React.Fragment>
    )
}